import { Reveal } from "@/components/Reveal";

export const SectionHeader = ({ chapter, kicker, title, subtitle, testId }) => (
    <Reveal className="mb-14 md:mb-20">
        <div className="mb-5 flex items-center gap-4">
            <span className="font-mono2 text-sm text-neon">{chapter}</span>
            <span className="h-px w-12 bg-neon/40" aria-hidden="true" />
            <span className="font-mono2 text-xs uppercase tracking-[0.3em] text-zinc-500">
                {kicker}
            </span>
        </div>
        <h2
            data-testid={testId}
            className="font-display text-4xl font-extrabold leading-none tracking-tighter text-zinc-100 sm:text-5xl"
        >
            {title}
        </h2>
        {subtitle && (
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-zinc-400 md:text-lg">
                {subtitle}
            </p>
        )}
    </Reveal>
);
